import { trackInteraction } from './analytics';
import { trackUserIdentity } from '../checkout/api/services/checkoutAnalytics';

export function initNavTrackingListeners() {
  const navLinks = document.getElementsByClassName('track-nav-link-click');
  for (let i = 0; i < navLinks.length; i++) {
    const linkEl = navLinks[i];
    linkEl.addEventListener('click', () => {
      trackInteraction({ label: 'Nav - Main links', toPath: linkEl.pathname });
    });
  }
}

export function initNavLogInTrackingListeners() {
  const logInLinks = document.getElementsByClassName('track-nav-log-in-click');
  for (let i = 0; i < logInLinks.length; i++) {
    const linkEl = logInLinks[i];
    linkEl.addEventListener('click', () => {
      trackUserIdentity();
    });
  }
}
